<template>
    <div>
        <h1>Contatos realizados pelo site</h1>
        <div class="container">
            <div class="row">
                <div class="col-sm-6 mb-2">
                    <div class="list-group">
                        <router-link to="/esinistros/formcontato" class="list-group-item" > 
                            Formulário de contato
                            <span class="badge badge-secondary float-right" style="margin-top: 3px;">{{countContato}}</span>
                        </router-link>
                    </div>                    
                </div>
                <div class="col-sm-6 mb-2">
                    <div class="list-group">
                        <router-link to="/esinistros/forminteresse" class="list-group-item" > 
                            Formulário de interesse
                            <span class="badge badge-secondary float-right" style="margin-top: 3px;">{{countInteresse}}</span>
                        </router-link>
                    </div>                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getData } from "../global/utils";

    export default {
        data: function () {
            return {
            stripe: true,
            colorAlert: "primary",
            titleAlert: "",
            segmentoId: "",
            activeAlert: false,
            countInteresse: 0,
            countContato: 0,
            countEquipe: 0,
            iconArea: 50 * 1,
            errors: [],
            erro: "",
            urlApi: "esinistros",
            carregando: true,
            deleteId: "",
            deleteAtivo: null,
            deleteTitulo: "",
            };
        },

        mounted() {
            this.fnCarregaItems();
            this.fnCarregaItemsContato();
            this.fnCarregaEquipe();
        },
        methods: {
            async fnCarregaItems() {
            let data = await getData(
                this.urlApi + "/servicosform"
            );
            console.log(data);
            this.countInteresse = data[0].content.length;
            this.carregando = false;
            this.$vs.loading.close();
            },
            async fnCarregaItemsContato() {
                let data = await getData(
                    this.urlApi + "/contatoform"
                );
                console.log(data);
                this.countContato = data[0].content.length;
                this.carregando = false;
                this.$vs.loading.close();
            },
            async fnCarregaEquipe() {
                let data = await getData(
                    this.urlApi + "/equipeform"
                );
                console.log(data);
                this.countEquipe = data[0].content.length;
                this.carregando = false;
                this.$vs.loading.close();
            },

        }        
    }        
</script>

<style lang="scss" scoped>

</style>